import { createStyles, makeStyles } from "@mui/styles";
import { CommonFonts, Colors } from "@/theme";

const useStyles = makeStyles((theme) =>
  createStyles({
    emptyText: {
      ...CommonFonts.darkBoldFont24,
      color: Colors.GRAY_BORDER,
    },
  })
);

export default useStyles;
